var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"outcomeNameDiv",staticClass:"outcomes-bet-outcome-name",class:[
    'outcomes-bet-outcome-name',
    { 'long-outcome-name': _vm.longOutcomeName },
  ]},[_c('span',{ref:"outcomeNameSpan"},[_vm._v(_vm._s(_vm.outcome.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }